import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sf-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Purchase Subscription", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IndividualPurchaseField = _resolveComponent("IndividualPurchaseField")!
  const _component_SagePay = _resolveComponent("SagePay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.step == 'products')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" Select Products "),
          (_ctx.mathsAvailable)
            ? (_openBlock(), _createBlock(_component_IndividualPurchaseField, {
                key: 0,
                modelValue: _ctx.products,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.products) = $event)),
                class: "sf-label-light"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onContinue && _ctx.onContinue(...args)), ["prevent"])),
              class: "sf-btn-primary"
            }, " Continue ")
          ])
        ]))
      : (_ctx.step == 'confirm')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.purchaseData)
              ? (_openBlock(), _createBlock(_component_SagePay, {
                  key: 0,
                  mode: "individual",
                  userId: _ctx.userId,
                  "purchase-data": _ctx.purchaseData
                }, null, 8, ["userId", "purchase-data"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}